import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const vatConstants = {
  GET_VAT_LINES_START: "GET_VAT_LINES_START",
  GET_VAT_LINES_SUCCESS: "GET_VAT_LINES_SUCCESS",
  GET_VAT_LINES_ERROR: "GET_VAT_LINES_ERROR",
  CLEAR_VAT_LINES: "CLEAR_VAT_LINES",

  GET_VAT_REGIMES_START: "GET_VAT_REGIMES_START",
  GET_VAT_REGIMES_SUCCESS: "GET_VAT_REGIMES_SUCCESS",
  GET_VAT_REGIMES_ERROR: "GET_VAT_REGIMES_ERROR",

  GET_VAT_DESTINATIONS_START: "GET_VAT_DESTINATIONS_START",
  GET_VAT_DESTINATIONS_SUCCESS: "GET_VAT_DESTINATIONS_SUCCESS",
  GET_VAT_DESTINATIONS_ERROR: "GET_VAT_DESTINATIONS_ERROR",

  GET_VAT_EXEMPTION_NATURES_START: "GET_VAT_EXEMPTION_NATURES_START",
  GET_VAT_EXEMPTION_NATURES_SUCCESS: "GET_VAT_EXEMPTION_NATURES_SUCCESS",
  GET_VAT_EXEMPTION_NATURES_ERROR: "GET_VAT_EXEMPTION_NATURES_ERROR",

  GET_VAT_COMPENSATION_START: "GET_VAT_COMPENSATION_START",
  GET_VAT_COMPENSATION_SUCCESS: "GET_VAT_COMPENSATION_SUCCESS",
  GET_VAT_COMPENSATION_ERROR: "GET_VAT_COMPENSATION_ERROR",

  GET_VAT_FLAT_RATES_START: "GET_VAT_FLAT_RATES_START",
  GET_VAT_FLAT_RATES_SUCCESS: "GET_VAT_FLAT_RATES_SUCCESS",
  GET_VAT_FLAT_RATES_ERROR: "GET_VAT_FLAT_RATES_ERROR"
};

export function clearVatLines() {
  return (dispatch) => {
    dispatch({
      type: vatConstants.CLEAR_VAT_LINES
    });
  };
}

export function getVatLines(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_LINES_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/vat?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_LINES_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_LINES_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getVatRegimes(reasonId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_REGIMES_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/regimes?itemId=${itemId}&managerId=${managerId}&reasonId=${reasonId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_REGIMES_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_REGIMES_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getVatWidget() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {     
      let request = {
        method: "GET",        
        url: `${API_PRECOG_URL_V1}/vat/widget?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {          
          resolve(result.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
}

export function getVatDestinations(active) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_DESTINATIONS_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/destinations?active=${active}&itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_DESTINATIONS_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_DESTINATIONS_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getVatExemptions(nature) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_EXEMPTION_NATURES_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/exemption-natures?itemId=${itemId}&managerId=${managerId}` + (nature ? `&nature=${nature}` : ""),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_EXEMPTION_NATURES_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_EXEMPTION_NATURES_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getVatCompensation() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_COMPENSATION_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/compensation-rates?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_COMPENSATION_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_COMPENSATION_ERROR,
            payload: err
          });
        });
    });
  };
}

export function getVatFlatRates() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: vatConstants.GET_VAT_FLAT_RATES_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/vat/flat-rates?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: vatConstants.GET_VAT_FLAT_RATES_SUCCESS,
            payload: {
              data: result.data
            }
          });
          resolve(result.data);
        })
        .catch((err) => {
          dispatch({
            type: vatConstants.GET_VAT_FLAT_RATES_ERROR,
            payload: err
          });
        });
    });
  };
}
